import {createSvgIcon} from "@mui/material";

const ClearIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M1 1L9 9" stroke="#E10B17" strokeWidth="2" strokeLinecap="round"/>
    <path d="M9 1L1 9" stroke="#E10B17" strokeWidth="2" strokeLinecap="round"/>
  </svg>,
  'Clear'
)

export default ClearIcon
